module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Cory Decarbonisation",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--cory-decarbonisation.netlify.app/' : 'https://corydecarbonisation.co.uk/',

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: 'https://feedback.corydecarbonisation.co.uk',
    // mapUrl: 'https://cory-decarbonisation-map.jfd-test.co.uk',
    //mapUrl: 'https://cory-map.test',

    base: {
        contact_address: "10 Dominion Street Floor 5 London EC2M 2EF",
        freepost_address: "FREEPOST CORY CCS (This is free of charge. You don’t need a stamp)",
        contact_number: "0330 830 4254",
        contact_email: "decarbonisation@corygroup.co.uk"
    },

    meta: {
        default_social_image: "/assets/images/social.jpg",
        author: "Cory Decarbonisation",
        description: "Cory has ambitious plans to capture the carbon dioxide emitted at our energy from waste (EfW) facilities in Belvedere. Our decarbonisation project also includes exploring the potential for producing low carbon hydrogen at our site, using the carbon negative electricity produced at our EfW facilities.",
        gtag: "G-GQ8ENC2GEV",
        gtm: "GTM-5MZQVPH"
    },

    form: {
        "feedback": {
            "catcher_id": "",
            "honeypot": "",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b"
        }
    },

    consultation: {
        "feedback_active": false,
        "start_datetime": "",
        "end_datetime": ""
    },

    examination: [
        {
            title: "Notice of hearings - 11 - 12 February 2025",
            url: "/assets/images/downloads/Cory-Decarbonisation-Project_Notice-of-Hearings.pdf",
        },
        {
            title: "Notice of hearings – 5 to 7 November 2024",
            url: "/assets/images/pdf/Cory_Decarbonisation_Project_Notice_of_Open_Floor_Hearing.pdf",
        },
    ],

    nmcConsultationdec: [
        {
            title: "NMC Consultation Notice",
            url: "/assets/images/downloads/December-2024-NMC-Consultation-Notice.pdf",
        },
    ],

    nmcConsultation: [
        {
            title: "NMC Consultation Notice",
            url: "/assets/images/pdf/NMC-Consultation-Notice-20-September-2024.pdf",
        },
        {
            title: "Indicative location map for proposed change",
            url: "/assets/images/pdf/NMC-Consultation-Proposed-change-location.pdf",
        },
    ],

    statConsultation: [
        {
            title: "Recording of online consultation event 15 Nov 2023",
            videoId: "885136390",
            type: "video",
        },
        {
            title: "Visualisation of site from Norman Road",
            url: "/assets/images/pdf/Norman_Road_Sketch_231109.jpg",
        },
        {
            title: "Brochure (Spread pages) - October 2023",
            url: "/assets/images/pdf/Cory-Statutory-Consultation-Autumn-2023-BROCHURE-A4-SPREADS.pdf",
        },
        {
            title: "Brochure (Single pages) - October 2023",
            url: "/assets/images/pdf/Cory-Statutory-Consultation-Autumn-2023-BROCHURE-A4-Landscape.pdf",
        },
        {
            title: "Feedback form - October 2023",
            url: "/assets/images/pdf/Cory-Statutory-Consultation-Autumn-2023-Feedback-Form.pdf",
        },
        {
            title: "Freepost card - October 2023",
            url: "/assets/images/pdf/Cory-Statutory-Consultation-Autumn-2023-FREEPOST-CARD.pdf",
        },
        {
            title: "Poster - October 2023",
            url: "/assets/images/pdf/Cory-Statutory-Consultation-Autumn-2023_A4_POSTER.pdf",
        },
        {
            title: "Statement of Community consultation - October 2023",
            url: "/assets/images/pdf/Cory-Statutory-Consultation-Autumn 2023_SoCC.pdf",
        },
    ],

    peir: [
        {
            title: "PEIR Volume 1: Chapters",
            url: "https://d294o5otoz8694.cloudfront.net/PEIR/Cory+Decarbonisation+Project+-+PEIR+-+Volume+1+-+Main+Text.pdf",
        },
        {
            title: "PEIR Volume 2: Figures",
            url: "https://d294o5otoz8694.cloudfront.net/PEIR/Cory+Decarbonisation+Project+-+PEIR+-+Volume+2+-+Figures.pdf",
        },
        {
            title: "PEIR Volume 3: Appendices",
            url: "https://d294o5otoz8694.cloudfront.net/PEIR/Cory+Decarbonisation+Project+-+PEIR+-+Volume+3+-+Technical+Appendices.pdf",
        }
    ],

    // Bugsnag API Key
    bugsnag_api_key: '01c4a649efd6ce4206efad9ef9005c8d',

    // Marker.io Key - replace this default key
    marker_io: '646ce0237715f44b621f34fb'
};